import { ISMSCommunication } from 'shared';
import { Tooltip } from '@mui/material';

import { WrappedLink } from '../../WrappedLink';
import { formatInboxDate } from '../common/formatInboxDate';
import { TruncatedTextWithTooltip } from '../common/TruncatedTextWithTooltip';

interface SmsInboxRowProps {
  sms: ISMSCommunication;
  onRowClick: (sms: ISMSCommunication) => void;
}

export function SmsInboxRow({ sms, onRowClick }: SmsInboxRowProps) {
  return (
    <tr
      className={ `cursor-pointer hover:bg-gray-50` }
      onClick={ () => onRowClick(sms) }
    >
      <td className={ `px-3 py-3 text-sm text-gray-700 whitespace-nowrap` }>{ formatInboxDate(sms.createdAt) }</td>
      <td className={ `px-3 py-3 text-sm text-gray-700 whitespace-nowrap` }>
        { sms.contactId ? (
          <WrappedLink
            className={ `inline text-blue-600 underline` }
            to={ `/contacts/${sms.contactId}` }
            onClick={ e => e.stopPropagation() }
          >
            <Tooltip title={ sms.contactName || `Contact #${sms.contactId}` }>
              <span className={ `inline-block truncate max-w-[220px] align-bottom` }>
                { sms.contactName || `Contact #${sms.contactId}` }
              </span>
            </Tooltip>
          </WrappedLink>
        ) : `-` }
      </td>
      <td className={ `px-3 py-3 text-sm text-gray-700 max-w-[220px]` }>
        <TruncatedTextWithTooltip value={ sms.from } />
      </td>
      <td className={ `px-3 py-3 text-sm text-gray-900 max-w-[460px]` }>
        <TruncatedTextWithTooltip value={ sms.body } />
      </td>
    </tr>
  );
}
